import React, { ReactElement } from "react";
import {
  defaultLayoutPlugin,
  ToolbarProps,
  ToolbarSlot,
} from "@react-pdf-viewer/default-layout";
import { pdfjs } from "react-pdf";
import {
  LocalizationMap,
  ProgressBar,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import classNames from "classnames";
import { Col, Row } from "react-bootstrap";
import RessourceEntity from "../../Entities/RessourceEntity.tsx";
import fr_FR from "./Traduction_FR.json";
import styles from "./ToolbarPdf.module.css";

const renderError = () => {
  return (
    <div className={styles.containerError}>
      <p className={styles.errorPdf}>Erreur lors du chargement du document</p>
    </div>
  );
};
const ViewWithToolbar = ({ url, telechargeable = false }: RessourceEntity) => {
  const renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => (
    <Toolbar>
      {(slots: ToolbarSlot) => {
        const {
          CurrentPageInput,
          Download,
          Print,
          EnterFullScreen,
          GoToNextPage,
          GoToPreviousPage,
          NumberOfPages,
          ShowSearchPopover,
          Zoom,
          ZoomIn,
          ZoomOut,
        } = slots;
        return (
          <Row>
            <Col className={"p-1"}>
              <ShowSearchPopover />
            </Col>
            <Col className={"p-1"}>
              <ZoomOut />
            </Col>
            <Col className={"p-1"}>
              <Zoom />
            </Col>
            <Col className={"p-1"}>
              <ZoomIn />
            </Col>
            <Col className={classNames(styles.btnRightPdf)}>
              <GoToPreviousPage />
            </Col>
            <Col className={"p-1"}>
              <CurrentPageInput /> / <NumberOfPages />
            </Col>
            <Col className={"p-1"}>
              <GoToNextPage />
            </Col>
            <Col className={classNames(styles.btnRightPdf)}>
              <EnterFullScreen />
            </Col>
            {telechargeable ? (
              <>
                <Col className={"p-1"}>
                  <Download />
                </Col>

                <Col className={"p-1"}>
                  <Print />
                </Col>
              </>
            ) : (
              ""
            )}
          </Row>
        );
      }}
    </Toolbar>
  );

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar,
  });

  return (
    <div className={classNames(styles.worker, "px-0 px-md-2 px-lg-4")}>
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}
      >
        <div className={"h-100 "}>
          <Viewer
            localization={fr_FR as LocalizationMap}
            fileUrl={url}
            plugins={[defaultLayoutPluginInstance]}
            renderError={renderError}
            renderLoader={(percentages: number) => (
              <div className={styles.progressBar}>
                <ProgressBar progress={Math.round(percentages)} />
              </div>
            )}
          />
        </div>
      </Worker>
    </div>
  );
};
export default ViewWithToolbar;
